import { TokenError } from './error.js';
import { OAuth2Token } from './OAuth2Token.js';
import { qsStringify } from './url.js';
import { parseResponseBody, getAuthError } from './utils.js';

var JSOAuth2 = /** @class */ (function () {
    function JSOAuth2(options) {
        var _this = this;
        /**
         * Create a new token from existing data.
         */
        this.createToken = function (data) { return new JSOAuth2.Token(_this, data); };
        /**
         * Using the built-in request method, we'll automatically attempt to parse
         * the response.
         *
         * @param  {Object}  options
         * @return {Promise}
         */
        this._request = function (options) {
            var url = options.url;
            var requestBody = qsStringify(options.body);
            var query = qsStringify(options.query);
            if (query) {
                url += (url.indexOf('?') === -1 ? '?' : '&') + query;
            }
            return _this.request(options.method, url, requestBody, options.headers).then(function (res) {
                var body = parseResponseBody(res.body);
                var authErr = getAuthError(body);
                if (authErr) {
                    return Promise.reject(authErr);
                }
                if (res.status < 200 || res.status >= 399) {
                    return Promise.reject(new TokenError(res));
                }
                return body;
            });
        };
        this.options = options;
        // this.code = new CodeFLow(this);
        // this.token = new TokenFLow(this);
        // this.owner = new OwnerFlow(this);
        // this.assertion = new AssertionFLow(this);
        // this.credentials = new CredentialsFlow(this);
        // this.jwt = new JwtBearerFlow(this);
    }
    JSOAuth2.prototype.request = function (method, url, requestBody, headers) {
        return fetch(url, {
            body: requestBody,
            method: method,
            headers: headers,
        }).then(function (res) {
            return res.text().then(function (body) { return ({ body: body, status: res.status }); });
        });
    };
    JSOAuth2.Token = OAuth2Token;
    return JSOAuth2;
}());

export { JSOAuth2 };
